import styled from '@emotion/styled';
import { NavLink } from 'react-router-dom';
// @mui
import MuiList from '@mui/material/List';
import MuiButton from '@mui/material/Button';
import MuiMenuItem from '@mui/material/MenuItem';
// @ld
import { colors } from '@ld/utils';
import { Avatar } from '@ld/core';

export const ASide = styled.aside`
  background-color: white;
  padding-top: 16px;
  width: 240px;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 10px;
`;

export const ActiveBorder = styled.div`
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 5px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: ${colors.green1};
`;

export const StyledLink = styled(NavLink)`
  &,
  &:link {
    width: 100%;
    padding: 8px;
    display: flex;
    padding: 16px;
    font-size: 18px;
    line-height: 140%;
    align-items: center;
    text-decoration: none;
    color: ${colors.black1};
    backface-visibility: hidden;
    font-family: 'Montserrat', sans-serif;
    position: relative;

    &.active {
      font-weight: 600;
      color: ${colors.green1};

      ${ActiveBorder} {
        display: block;
      }
    }
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 16px;
`;

export const Footer = styled.div`
  display: block;
`;

export const Button = styled(MuiButton)`
  && {
    display: flex;
    padding: 20px 30px;
    border-radius: 0px;
    background: #ffffff;
    font-weight: normal;
    color: ${colors.black1};
    justify-content: flex-start;
    background-color: transparent;

    .MuiButton-startIcon {
      margin-left: 0px;
      margin-right: 15px;
    }

    .MuiButton-iconSizeMedium > *:first-of-type {
      font-size: 16px;
    }

    &:hover {
      background: #ffffff;
      color: ${colors.black1};
    }
  }
`;

export const Menu = styled(MuiList)`
  && {
    background-color: rgba(0, 0, 0, 0.04);
    padding: 0;

    .MuiListItem-button {
      color: ${colors.black1};
      padding: 10px 30px 10px 10px;
    }
  }
`;

export const StyledAvatar = styled(Avatar)`
  && {
    width: 30px;
    height: 30px;
    font-weight: 600;
    line-height: 20px;
  }
`;

export const MenuItem = styled(MuiMenuItem)`
  && {
    .MuiListItemIcon-root {
      min-width: 43px;
      margin-left: 15px;
    }
  }
`;

export const OrganisationLogo = styled.img`
  width: 180px;
  height: auto;
`;

export const PoweredByLink = styled.a`
  &,
  &:link,
  &:hover,
  &:active,
  &:visited {
    display: flex;
    padding: 5px;
    margin-top: 10px;
    align-items: center;
    border-radius: 50px;
    border: 1px solid ${colors.grey5};
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 22px;
    white-space: nowrap;
    color: ${colors.black1};
    text-decoration: none;
  }
`;
